import { render, staticRenderFns } from "./UmsTenants.vue?vue&type=template&id=150c705d&"
import script from "./UmsTenants.vue?vue&type=script&lang=js&"
export * from "./UmsTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports